<template>
  <core-empty-state
    class="!max-w-5xl"
    :heading="heading"
    :description="description"
    :image="emptyTimelineImage"
    image-class="mb-8 w-full max-w-4xl"
  >
    <div v-if="canUpload && !notStarted" class="mt-8 flex justify-center">
      <u-button
        label="Upload Photos"
        :icon="COMMON_ICONS.upload"
        color="heroblue"
        size="xl"
        @click="uploadPhotos"
      />
    </div>
  </core-empty-state>
</template>

<script setup>
  import emptyTimelineImage from '~/assets/images/timeline/empty-timeline.svg';

  const props = defineProps({
    canUpload: Boolean,
    notStarted: Boolean
  });
  const emit = defineEmits(['refresh']);

  const heading = computed(() => {
    if (props.notStarted) return 'Your timeline is on the way';
    return props.canUpload ? 'Your timeline is waiting' : 'No timeline memories yet';
  });
  const description = computed(() => {
    if (props.notStarted) return 'It will be available in your account soon. Please check back later.';
    return props.canUpload
      ? 'Upload your photos and we\'ll automatically organize them into a timeline sorted by year and decade — powered by ethical AI.'
      : 'This timeline does not have any memories to display yet.';
  });

  async function uploadPhotos() {
    await useUploadActions().openUploaderModal();
    emit('refresh');
  }
</script>
